<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left"></div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>
        <div class="scrollbar-container">
            <div class="header top">
                <div class="label">{{ $tc('pages.employeeContext.planning', 2) }}</div>
            </div>
            <datatable :state="dataTableState" style="margin-bottom: 60px;" />
            <div v-if="loading" class="loading-md bg">
                <i class="fas fa-spinner"></i>
                <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                    {{ loadingText }}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import datatable from '../uicomponents/datatable.vue';
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'employeetypeoverviewtable',
        components: {
            datatable,
        },
        data () {
            return {
                loadingText: this.$t('global.ui.loadX', [this.$tc('pages.employeeContext.planning', 2)]),
                employeeTypeId: undefined,
                employeeTypeTemplateId: null,
                employeeType: {
                    name: "",
                    monthTimeMaxType: 1,
                    monthTimeMaxAdjustment: 0,
                    weekTimeMax: 60,
                    weekTimeRegular: 40,
                    dayTimeMax: 12,
                    dayTimeRegular: 8,
                    restTime: 11,
                    allowMultipleShifts: false,
                    shiftBetweenTimeMin: 0,
                    shiftBetweenTimeMax: 3,
                    limitConsecutiveDays: false,
                    daysConsecutiveMax: 6,
                    limitOvertime: false,
                    monthOvertimeMax: 20,
                    overtimeCutoff: 480,
                    useWorkDaysForSpareTime: false,
                    weekWorkDaysMax: 1,
                    weekWorkDaysRegular: 5,
                    weekSpareDaysMin: 1,
                    weekAdditionalSpareTime: 12,
                    weekTimeAvgType: 1,
                    weekSpareTimeStartType: 1,
                    weekSpareTimeStart: null,
                    monthTimeRegular: Math.round(40 * 4.325),
                },

                currentTypeRow: {},
                typeerror: false,
                loading: true,
                displayInactiveConctractTemplates: false,
                
            }
        },
        created: function () {
            if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();
            }
        },
        computed: {
            ...mapGetters(['storeId', 'employeeTypeMap', 'employeeTypeTemplateMap', 'allowedContractMap']),
            headerButtons() {
                let view = this;
                let helperLinks = [];
                
                let buttons = [
                    {
                        type: "block",
                        icon: "fa-sync-alt",
                        click: () => {
                        view.refresh(true); 
                        },
                        tooltip: this.$t('global.general.refreshData')
                    },
                    {
                        classes: "add-employeetype",
                        type: "block green",
                        disabled: false,
                        icon: "fa-plus",
                        click: ($event) => { 
                            this.CreateType($event);
                            },
                        show:  true,
                        tooltip: this.$t('global.ui.createX', [this.$t('pages.employeeContract.planningEmployeeType')]),
                        helperText: this.$t('pages.comp.createPlanningGuideHelp'),
                        //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
                    }
                ];
                helperLinks.push(
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/12",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                );
                let state= {
                    buttons: buttons,
                    helperLinks: helperLinks,
                    showListIconAlways: true
                    };
                return state;
            },
            sideButtons() {
                let view = this;

                let state = {
                    buttons: [
                        {
                            type: 'block border',
                            icon: 'fa-eye',
                            tooltip: this.$t('store.templates.viewOptions'),
                            click: ($event) => {
                                view.OpenMenuDetails($event, this.displayMenuState);
                            },

                        },
                        
                    ]
                };


                return state;
            },
            displayMenuState() {
                const displayItems = [
                    {
                        closeOnClick: true,
                        icon: !this.displayInactiveConctractTemplates ? 'fa-toggle-off' : 'fa-toggle-on',
                        text: this.$t('pages.comp.showInactivePlanningGuides'),
                        click: () => this.$set(this, 'displayInactiveConctractTemplates', !this.displayInactiveConctractTemplates),
                    },
                    
                ];

                

                return {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('shift.template.view'),
                            items: displayItems
                        },
                        
                    ],
                    items: [],
                };
            },
            dataTableState(){
                let view = this;
                let state = {};
                let types = Object.values(this.employeeTypeMap).filter(t => {
                    return this.displayInactiveConctractTemplates  || this.employeeTypeTemplateMap[t.templateId].contractId == null || this.allowedContractMap[this.employeeTypeTemplateMap[t.templateId].contractId].active;
                });
                types.sort((a, b) => {

                    return b.weekTimeRegular - a.weekTimeRegular;//a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                })
                state = this.$helpers.GetDataTableStateFromObject({
                    name: '',
                    weekTimeRegular: '',
                }, types);
                state.headerMap['name'].sort = true;
                state.headerMap['name'].align = 'left';
                state.headerMap['name'].alignHeaderLabel = 'left';
                state.headerMap['name'].DisplayLabel = (i) => {return i.name};
                state.headerMap['weekTimeRegular'].label = this.$t('pages.employeeContract.weekTimeRegular');
                state.headerMap['weekTimeRegular'].sort = true;
                state.headerMap['weekTimeRegular'].align = 'left';
                state.headerMap['weekTimeRegular'].alignHeaderLabel = 'left';
                state.headerMap['weekTimeRegular'].DisplayLabel = (i) => {return (i.weekTimeRegular/60).toFixed(2)};
                state.headerMap['actions'] = {buttons:[
                        {icon: 'fas fa-eye', action: ($event, data) => view.ViewType($event, data)},
                        {icon: 'fas fa-edit', action: ($event, data) => view.EditType($event, data)},
                        {icon: 'fas fa-trash', action: ($event, data) => view.DeleteType($event, data)},
                    ]};
                state.headerMap['actions'].width = '120px';
                
                return state;
            },
            monthTimeRegular(){
                return Math.round(this.employeeType.weekTimeRegular * 4.325);
            },

        },
        watch: {
            storeId(newVal, oldVal){
                this.refresh();
            }
        },
        // methods that implement data logic.
        methods: {
            refresh: function(forced = false){
                
                let view = this;
                this.loading = true;
                this.$helpers.GetAllowedContractMap(forced)
                .then(response => {
                    return view.$helpers.GetEmployeeTypeTemplateMap(forced)  
                })
                .then(response => {
                    return view.$helpers.GetEmployeeTypeMap(forced)
                }).then(response => {
                    view.loading = false;
                }).catch(function (error) {
                    console.log(error)
                })
            },
            DeleteType($event, data){
                let view = this;
                view.$helpers.OpenAlert({header: view.$t('global.ui.deleteX', [view.$t('pages.employeeContract.planningEmployeeType')]), description: view.$t('pages.comp.deletePlanningGuideQuery', [data.name]), callbackAccept: (alert) => {
                        alert.hidden = true;
                        view.$helpers.DeleteCall('/api/sec/employeetype', data, () => {
                            view.$store.commit("deleteEmployeeTypeMapEntry", {id: data.id});
                        });
                    }});
            },
            OpenMenuDetails($event, state) {
                
                this.$helpers.OpenPopup({
                    type: 'burgermenu',
                    componentState: state,
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            CreateType($event, data){
                let view = this;
                
                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'employeetypeform',
                    componentState: {employeeTypeTemplateMap: this.employeeTypeTemplateMap},
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: this.$t('global.ui.newX', [this.$t('pages.employeeContract.planningEmployeeType')]),
                    customEventName:"created-employeetype",
                    customEventHandler:(data) => { view.$store.commit("setEmployeeTypeMapEntry", data);}
                });
            },
            EditType($event, data){
                let view = this;
                
                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'employeetypeform',
                    componentState: {employeeTypeTemplateMap: this.employeeTypeTemplateMap, employeeType: data},
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: this.$t('global.ui.editX', [this.$t('pages.employeeContract.planningEmployeeType')]),
                    customEventName:"updated-employeetype",
                    customEventHandler:(data) => {delete data.updateFields; view.$store.commit("setEmployeeTypeMapEntry", data); }
                });
            },
           
            ViewType($event, data){
                let view = this;

                let typeTemp = {};
                let name = data.name;
                typeTemp.templateName = this.employeeTypeTemplateMap[data.templateId] ? this.employeeTypeTemplateMap[data.templateId].name : '';
                typeTemp.monthTimeRegular = data.monthTimeRegular / 60;
                typeTemp.weekTimeRegular = data.weekTimeRegular / 60;
                typeTemp.dayTimeRegular = data.dayTimeRegular / 60;
                typeTemp.restTime = data.restTime / 60;

                let datafillState = view.$helpers.GetDataFillStateFromObject(typeTemp);
                Object.values(datafillState.entries).forEach(e => {
                    e.flexGroup = true;
                    e.styles = {width: '50%'};
                });

                datafillState.entries.templateName.label = this.$tc('pages.employeeContract.template');
                datafillState.entries.templateName.styles = {width: '50%', left : '-25%'};
                datafillState.entries.templateName.flexRowEnd = true;
                datafillState.entries.monthTimeRegular.label = this.$t('roster.main.monthlyTargetHours');
                datafillState.entries.weekTimeRegular.label = this.$t('roster.main.weeklyTargetHours');
                datafillState.entries.weekTimeRegular.flexRowEnd = true;
                datafillState.entries.dayTimeRegular.label = this.$t('roster.main.dailyTargetHours');
                datafillState.entries.restTime.label = this.$t('roster.main.restTime');
                datafillState.entries.restTime.flexRowEnd = true;

                datafillState.displayOnly = true;

                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: datafillState,
                    expanded: true,
                    centered: true,
                    width: '1000px',
                    header: name,
                });
            },

            
            
        },

    }
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
    .header.top{
        margin: 10px 0px 10px 8px;
    }
    .data-table{
        top: 10px;
        position: relative;
    }
    .employee-type-table{
        padding: 0px 14px;
    }
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        overflow-x: hidden;
        top: var(--header-height);
        padding: 0px 14px;
    }
</style>
